var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconThreeDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 15.1046 9.10457 16 8 16C6.89543 16 6 15.1046 6 14C6 12.8954 6.89543 12 8 12C9.10457 12 10 12.8954 10 14Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14Z",
    fill: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14C22 15.1046 21.1046 16 20 16C18.8954 16 18 15.1046 18 14C18 12.8954 18.8954 12 20 12C21.1046 12 22 12.8954 22 14Z",
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconThreeDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-three-dots.a4516a056ca366650a97c18e4a8cdd9e.svg";